import { ref } from 'vue'

const notifications = ref([])

export function useNotify() {
  return {
    notifications,
    notify(notification) {
      const id = notifications.value.length
      notifications.value.push({
        ...notification,
        id,
      })
      setTimeout(() => {
        this.removeNotification(id)
      }, 3000)
    },
    removeNotification(id) {
      notifications.value = notifications.value.filter((n) => n.id !== id)
    },
    clearNotifications() {
      notifications.value = []
    },
  }
}
